/**
 * NSO outer site (`/nso/*`) — public homepage of the web app.
 *
 * Route split (do not conflate):
 *
 * | Surface | Paths | Login |
 * | --- | --- | --- |
 * | **Outer / public** | `/nso/*` | Optional — dev gate only until release |
 * | **NiData intra** | `/`, `/report`, `/team`, … | Always required (`AuthenticatedRoute`) |
 *
 * The outer site is released (`NSO_PUBLIC_SITE_RELEASED = true`): `/nso` is open to everyone.
 * It does **not** change intra: reporting and internal workflows stay login-gated.
 * Guests who open `/` are sent to `/nso`. Signed-in users still land on their NiData home.
 *
 * Hospital LAN Intranet (`NSO_INTRANET_URL` in siteConfig) is a separate external link, not NiData.
 */
export const NSO_PUBLIC_SITE_RELEASED = true;

/** Dev-only allowlist while `NSO_PUBLIC_SITE_RELEASED` is false. */
export const NSO_PREVIEW_ALLOWED_UIDS = ['FDbScvYwK9NguMvSOflJmVrysi12'] as const;

/** Preview access for `/nso/*` only — not used for NiData intra routes. */
export function canAccessNsoPublicSite(uid: string | null | undefined): boolean {
  if (NSO_PUBLIC_SITE_RELEASED) return true;
  if (!uid) return false;
  return NSO_PREVIEW_ALLOWED_UIDS.includes(uid as (typeof NSO_PREVIEW_ALLOWED_UIDS)[number]);
}

export function isNsoPublicPath(pathname: string): boolean {
  return pathname === '/nso' || pathname.startsWith('/nso/');
}
